module.exports = __webpack_public_path__ + "img/ala.c26f8374.svg";